import { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/lib/supabase";
import { AuthCard } from "./AuthCard";
import { AuthButton } from "./AuthButton";
import { useNavigate } from "react-router-dom";
import { authService } from '@/services';
import { useAuth } from "@/contexts/AuthContext";
import { LoginFormData, LoginFormProps } from '@/types';



export const LoginForm: React.FC<LoginFormProps> = ({ onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  
  const form = useForm<LoginFormData>({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async (data: LoginFormData) => {
    setIsLoading(true);
    try {
      const response = await authService.signIn(data.email, data.password);
      if ('error' in response) {
        toast({
          variant: "destructive",
          title: "Error",
          description: "The email or password are incorrect, try again."
        });
        form.setError('email', { message: ' ' });
        form.setError('password', { message: ' ' });
        return;
      }
      toast({
        title: "Success",
        description: "Logged in successfully!"
      });
      form.reset();
      onSuccess?.();
      navigate("/albums");
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "The email or password are incorrect, try again."
      });
      form.setError('email', { message: ' ' });
      form.setError('password', { message: ' ' });
    } finally {
      setIsLoading(false);
    }
  };  
      
  return (
    <AuthCard title="">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email</FormLabel>
                <FormControl>
                  <Input
                    placeholder="Enter your email"
                    type="email"
                    disabled={isLoading}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Password</FormLabel>
                <FormControl>
                  <Input
                    placeholder="Enter your password"
                    type="password"
                    disabled={isLoading}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <AuthButton isLoading={isLoading}>
            Login
          </AuthButton>
        </form>
      </Form>
    </AuthCard>
  );
};